<template>
  <doctor-form
    :hasWritePerm="hasWritePerm"
    :visible="newDoctorDialog"
    :dialogTitle="'hfManagement.newDoctorDialogTitle'"
    :doctor="doctor"
    :serviceList="serviceList"
    :initFormValid="false"
    @close="closeNewDoctorDialog"
    @setdoctorname="setDoctorName"
    @setdoctorsurname="setDoctorSurname"
    @setservicelist="setServiceList"
    @savedoctor="addDoctor"
  />
</template>

<script>
import HFDoctorForm from "./HFDoctorForm";

export default {
  components: {
    DoctorForm: HFDoctorForm
  },
  props: {
    hasWritePerm: {
      type: Boolean,
      required: true
    },
    newDoctorDialog: {
      type: Boolean,
      required: true
    },
    officeId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      doctor: {
        name: "",
        surname: ""
      },
      serviceList: []
    };
  },
  methods: {
    closeNewDoctorDialog() {
      this.resetForm();
      this.$emit("closenewdoctordialog");
    },
    resetForm() {
      this.doctor = {
        name: "",
        surname: ""
      };
      this.serviceList = [];
    },
    setDoctorName(name) {
      this.doctor.name = name;
    },
    setDoctorSurname(surname) {
      this.doctor.surname = surname;
    },
    setServiceList(serviceList) {
      this.serviceList = serviceList;
    },
    addDoctor() {
      this.$store
        .dispatch("doctors/addDoctor", {
          officeId: this.officeId,
          newDoctor: this.doctor
        })
        .then(doctorId => {
          return this.allAddServicePromises(doctorId);
        })
        .then(() => {
          this.closeNewDoctorDialog();
        })
        .then(() => {
          return this.$store.dispatch(
            "doctors/fetchDoctorServiceList",
            this.officeId
          );
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {});
    },
    allAddServicePromises(doctorId) {
      return Promise.all(
        this.serviceList.map(this.singleAddServicePromise(doctorId))
      );
    },
    singleAddServicePromise(doctorId) {
      return service => {
        return new Promise((resolve, reject) => {
          return this.$store
            .dispatch("doctors/updateDoctorService", {
              doctorService: {
                doctorId,
                serviceId: service.serviceId
              },
              service
            })
            .then(() => {
              resolve();
            })
            .catch(error => {
              reject(error);
            });
        });
      };
    }
  }
};
</script>
